import { apiRequest } from './api'

export function listReceipts() {
  return apiRequest('/receipts/list', {
    method: 'POST',
  })
}

export function createReceipt(payload) {
  return apiRequest('/receipts/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateReceipt(payload) {
  return apiRequest('/receipts/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteReceipt(receiptId) {
  return apiRequest('/receipts/delete', {
    method: 'POST',
    body: JSON.stringify({ receiptId }),
  })
}
